<template>
  <div class="bdg-input" :class="{ invalid }" @focusout="$emit('focusout')">
    <label v-if="name">
      <span>
        {{ name }} <span v-if="!required">(Optional)</span>
        <a class="ml-2" @click="$emit('remove')" v-if="removable">
          <i class="fal fa-trash-alt fa-fw text-red" />
        </a>
      </span>
      <span v-if="invalid && invalidText">
        {{ invalidText }}
      </span>
    </label>
    <slot v-if="!loading" />
    <div class="loading-state" v-else>
      <i class="fal fa-sun fa-spin text-red" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BdgInputTemplate",
  props: {
    name: String,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    invalid: Boolean,
    invalidText: { type: String, default: "* Field required" },
    removable: Boolean,
    loading: Boolean
  },
  data() {
    return {
      isInvalid: false
    };
  }
};
</script>

<style lang="scss" scoped>
:not(.flex-row):not(.flex) {
  & > .bdg-input {
    &:not(:first-child) {
      @apply mt-4;
    }
  }
}

.flex:not(.flex-col),
.flex-row {
  & > .bdg-input {
    &:not(:first-child) {
      @apply ml-4;
    }
  }
}

.bdg-input {
  &.invalid {
    label {
      @apply text-red;
    }
  }

  & > label:first-child {
    @apply flex justify-between text-sm;
  }

  & > .loading-state {
    @apply w-full py-3 text-center;
  }
}
</style>
